import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class LearnIcon extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22">
        <title>Learn</title>
        <path fillRule="nonzero"
          fill={this.props.active ? '#ffffff' : '#979797'}
          d="M11 2.72V22L.737
          19.17A1.01 1.01 0 0 1 0
          18.196V1.011C0
          .695.146.399.393.207a.998.998 0 0 1
          .87-.172L11 2.72zM23.607.207c.247.192.393.488.393.804v17.184c0
          .456-.302.856-.737.976L13 22V2.72L22.737.034c.298-.08.622-.018.87.172z" />
      </svg>
    );
  }
}

LearnIcon.propTypes = {
  active: PropTypes.bool
};
